import { useNetwork } from 'wagmi'
import { useMemo } from 'react'
import { useRequest } from 'ahooks'
import { useProviderOrSigner } from './useProviderOrSigner'
import { getVaultContract } from '@/utils/contract'
import { DepositCallParams, depositCall, feeCall } from '@/web3/contractCalls/vault'

export function useVaultContract(withSignerIfPossible = true) {
  const { chain } = useNetwork()
  const providerOrSigner = useProviderOrSigner(withSignerIfPossible)

  return useMemo(() => getVaultContract(providerOrSigner, chain?.id), [chain?.id, providerOrSigner])
}

export const useFee = (options?: { ready?: boolean }) => {
  const contract = useVaultContract()

  return useRequest(
    () => {
      if (!contract) {
        return Promise.reject(Error('Failed to create vault contract'))
      }
      return feeCall(contract)
    },
    {
      ready: options?.ready ?? true,
      cacheKey: 'Vault_Fee',
      onError: (error) => {
        console.log('fee error: ', error)
      },
    },
  )
}

export const useDeposit = (options?: { onSuccess?: () => void }) => {
  const vaultContract = useVaultContract()

  const { data: fee } = useFee()

  return useRequest(
    async ({ amount, tokenAddress, receiverAddress }: Omit<DepositCallParams, 'contract' | 'fee'>) => {
      return depositCall({ contract: vaultContract, tokenAddress, amount, receiverAddress, fee })
    },
    {
      manual: true,
      ready: !!fee,
      onSuccess: () => {
        options?.onSuccess?.()
      },
    },
  )
}
